import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useWorkspace } from "@/context/WorkspaceContext";
import Layout from "@/components/Layout";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const { workspace } = useWorkspace();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-paper">
        <div className="text-ink-3 text-sm font-mono-data">Loading MovaRaBoard…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  // Super Admin must select a workspace before any operational screen mounts.
  // Render the Layout shell (which shows the select-workspace prompt) instead of
  // the page so its data fetches never fire (avoids expected 409s).
  const needsWorkspace =
    user.role === "super_admin" &&
    !workspace &&
    location.pathname.startsWith("/app") &&
    !location.pathname.startsWith("/app/admin");
  if (needsWorkspace) return <Layout />;

  return children;
}
